import React from 'react';
import {RequireAuthentication_catererAccount} from '../../__generated__/RequireAuthentication';

export default React.createContext<RequireAuthentication_catererAccount | null>(null);
